import { putApiGalaxyServer } from 'services';

/** rails caps one request at 500 members. */
export const SIGN_IN_STATUS_BATCH_LIMIT = 500;

export interface BulkUpdateMembersSignInStatusPayload {
  team_id: number;
  team_membership_ids: number[];
  /** false turns sign-in off and ends the members' sessions; true turns it back on. */
  login_enabled: boolean;
}

/** One row per requested member. A refused member carries rails' reason. */
export interface MemberSignInStatusResult {
  id: number;
  account_id: number;
  success: boolean;
  login_enabled?: boolean;
  error_message?: string;
}

export interface BulkUpdateMembersSignInStatusResponse {
  team_members: MemberSignInStatusResult[];
  errors?: string[];
}

/**
 * Turn sign-in on or off for members of one team (GLX-2012), through galaxy-server's rails proxy.
 * rails answers 200 when any member succeeded, 400 with the same body when every member was refused.
 */
export const bulkUpdateMembersSignInStatusApi = ({
  params,
  token,
  config,
}: BaseApiParams<BulkUpdateMembersSignInStatusPayload>) =>
  putApiGalaxyServer<BulkUpdateMembersSignInStatusPayload, BulkUpdateMembersSignInStatusResponse>(
    `/rails_api/team_memberships/bulk_update_status`,
    params,
    config ?? {},
    token,
  );
